function compareNumbers(a, b) {
  return a - b;
};


function arraysEqual (arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i = i + 1) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

export function arrayDiffCounting(oldArray, newArray) {
  let count = 0;
  let foundNew = [];
  for (let i = 0; i < newArray.length; i += 1) {
    if (!oldArray.includes(newArray[i])) {
      count += 1;
      foundNew.push(newArray[i]);
    }
  }
  return { count, foundNew };
};


// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/utils.js